import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export interface FieldMessageProps {
  id?: string;
  tone?: 'hint' | 'error';
  children: ReactNode;
  className?: string;
}

/** Small helper / error text shown under a form field. Use `tone="error"` for validation messages. */
export default function FieldMessage({ id, tone = 'hint', children, className }: FieldMessageProps) {
  if (!children) return null;
  return (
    <span
      id={id}
      role={tone === 'error' ? 'alert' : undefined}
      className={cn('block text-xs font-normal', tone === 'error' ? 'text-(--accent-danger)' : 'text-(--text-tertiary)', className)}
    >
      {children}
    </span>
  );
}
